module.exports = __webpack_public_path__ + "app-static/img/face-2.794b94a2.png";